/* ============================================================
   APP JSPAINT — jspaint.app in an OS9 window + Squiche Filters
   squiche.com
   ============================================================ */

(function () {
  'use strict';

  function injectFilterStyles() {
    if (document.getElementById('jspaint-filter-styles')) return;
    var s = document.createElement('style');
    s.id = 'jspaint-filter-styles';
    s.textContent =
      '.psf-label{font-size:10px;color:#555;padding:4px 0 2px;font-family:\'Geneva\',\'Lucida Sans\',sans-serif;}' +
      '.psf-row{display:flex;gap:4px;margin-bottom:3px;}' +
      '.psf-btn{flex:1;height:22px;font-family:\'Geneva\',\'Lucida Sans\',sans-serif;font-size:11px;' +
        'background:#d4d0c8;border-top:1px solid #fff;border-left:1px solid #fff;' +
        'border-right:1px solid #555;border-bottom:1px solid #555;' +
        'cursor:pointer;color:#000;padding:0 4px;white-space:nowrap;overflow:hidden;' +
        'text-overflow:ellipsis;text-align:left;}' +
      '.psf-btn:active{border-top:1px solid #555;border-left:1px solid #555;' +
        'border-right:1px solid #fff;border-bottom:1px solid #fff;}' +
      '.psf-btn.psf-busy{background:#000080;color:#fff;border-top:1px solid #555;border-left:1px solid #555;' +
        'border-right:1px solid #fff;border-bottom:1px solid #fff;}' +
      '.psf-divider{height:1px;background:#888;box-shadow:0 1px 0 #fff;margin:4px 0;}';
    document.head.appendChild(s);
  }

  /* ── Filter helpers ── */
  function clamp(v) { return v < 0 ? 0 : v > 255 ? 255 : v | 0; }

  function filterGrayscale(data) {
    var out = new Uint8ClampedArray(data);
    for (var i = 0; i < out.length; i += 4) {
      var g = clamp(0.299 * out[i] + 0.587 * out[i + 1] + 0.114 * out[i + 2]);
      out[i] = out[i + 1] = out[i + 2] = g;
    }
    return out;
  }

  function filterBrightness(data) {
    var out = new Uint8ClampedArray(data);
    for (var i = 0; i < out.length; i += 4) {
      out[i]     = clamp(out[i]     + 25);
      out[i + 1] = clamp(out[i + 1] + 25);
      out[i + 2] = clamp(out[i + 2] + 25);
    }
    return out;
  }

  function filterDarken(data) {
    var out = new Uint8ClampedArray(data);
    for (var i = 0; i < out.length; i += 4) {
      out[i]     = clamp(out[i]     - 25);
      out[i + 1] = clamp(out[i + 1] - 25);
      out[i + 2] = clamp(out[i + 2] - 25);
    }
    return out;
  }

  function applyContrastRaw(data, fac) {
    var out = new Uint8ClampedArray(data);
    for (var i = 0; i < out.length; i += 4) {
      out[i]     = clamp(fac * (out[i]     - 128) + 128);
      out[i + 1] = clamp(fac * (out[i + 1] - 128) + 128);
      out[i + 2] = clamp(fac * (out[i + 2] - 128) + 128);
    }
    return out;
  }

  function filterContrast(data) {
    return applyContrastRaw(data, (259 * 355) / (255 * 159));
  }

  function applySaturateRaw(data, factor) {
    var out = new Uint8ClampedArray(data);
    for (var i = 0; i < out.length; i += 4) {
      var mean = (out[i] + out[i + 1] + out[i + 2]) / 3;
      out[i]     = clamp(mean + (out[i]     - mean) * factor);
      out[i + 1] = clamp(mean + (out[i + 1] - mean) * factor);
      out[i + 2] = clamp(mean + (out[i + 2] - mean) * factor);
    }
    return out;
  }

  function filterSaturate(data) {
    return applySaturateRaw(data, 2);
  }

  function filterInvert(data) {
    var out = new Uint8ClampedArray(data);
    for (var i = 0; i < out.length; i += 4) {
      out[i]     = 255 - out[i];
      out[i + 1] = 255 - out[i + 1];
      out[i + 2] = 255 - out[i + 2];
    }
    return out;
  }

  function applyNoiseRaw(data, amount) {
    var out = new Uint8ClampedArray(data);
    for (var i = 0; i < out.length; i += 4) {
      var n = (Math.random() * 2 - 1) * amount;
      out[i]     = clamp(out[i]     + n);
      out[i + 1] = clamp(out[i + 1] + n);
      out[i + 2] = clamp(out[i + 2] + n);
    }
    return out;
  }

  function filterNoise(data) {
    return applyNoiseRaw(data, 30);
  }

  function convolve3x3(data, w, h, kernel, divisor) {
    var out = new Uint8ClampedArray(data.length);
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        var i = (y * w + x) * 4;
        for (var c = 0; c < 3; c++) {
          var sum = 0;
          for (var ky = -1; ky <= 1; ky++) {
            for (var kx = -1; kx <= 1; kx++) {
              var nx = Math.min(w - 1, Math.max(0, x + kx));
              var ny = Math.min(h - 1, Math.max(0, y + ky));
              sum += data[(ny * w + nx) * 4 + c] * kernel[(ky + 1) * 3 + (kx + 1)];
            }
          }
          out[i + c] = clamp(sum / divisor);
        }
        out[i + 3] = data[i + 3];
      }
    }
    return out;
  }

  function filterBlur(data, w, h) {
    return convolve3x3(data, w, h, [1, 2, 1, 2, 4, 2, 1, 2, 1], 16);
  }

  function filterSharpen(data, w, h) {
    return convolve3x3(data, w, h, [-1, -1, -1, -1, 9, -1, -1, -1, -1], 1);
  }

  function filterHalftone(data, w, h) {
    var canvas = document.createElement('canvas');
    canvas.width = w; canvas.height = h;
    var ctx = canvas.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, w, h);
    ctx.fillStyle = '#000';
    var cell = 7;
    for (var cy = 0; cy < h; cy += cell) {
      for (var cx = 0; cx < w; cx += cell) {
        var sum = 0, cnt = 0;
        for (var dy = 0; dy < cell && cy + dy < h; dy++) {
          for (var dx = 0; dx < cell && cx + dx < w; dx++) {
            var pi = ((cy + dy) * w + (cx + dx)) * 4;
            sum += 0.299 * data[pi] + 0.587 * data[pi + 1] + 0.114 * data[pi + 2];
            cnt++;
          }
        }
        var r = (1 - (sum / cnt) / 255) * (cell / 2) * 0.9;
        if (r > 0.5) {
          ctx.beginPath();
          ctx.arc(cx + cell / 2, cy + cell / 2, r, 0, Math.PI * 2);
          ctx.fill();
        }
      }
    }
    return ctx.getImageData(0, 0, w, h).data;
  }

  function filterPosterize(data) {
    var out = new Uint8ClampedArray(data);
    var s = 255 / 4;
    for (var i = 0; i < out.length; i += 4) {
      out[i]     = clamp(Math.round(out[i]     / s) * s);
      out[i + 1] = clamp(Math.round(out[i + 1] / s) * s);
      out[i + 2] = clamp(Math.round(out[i + 2] / s) * s);
    }
    return out;
  }

  function filterGlitch(data, w, h) {
    var out = new Uint8ClampedArray(data);
    for (var y = 0; y < h; y++) {
      if (Math.random() < 0.12) {
        var shift = Math.round((Math.random() * 2 - 1) * 30);
        for (var x = 0; x < w; x++) {
          var sx = Math.min(w - 1, Math.max(0, x + shift));
          var di = (y * w + x) * 4;
          var si = (y * w + sx) * 4;
          out[di]     = data[si];
          out[di + 1] = data[si + 1];
          out[di + 2] = data[si + 2];
        }
      }
    }
    return out;
  }

  function filterVibe(data) {
    var out = new Uint8ClampedArray(data);
    for (var i = 0; i < out.length; i += 4) {
      out[i]     = clamp(out[i]     + (Math.random() * 2 - 1) * 70);
      out[i + 1] = clamp(out[i + 1] + (Math.random() * 2 - 1) * 70);
      out[i + 2] = clamp(out[i + 2] + (Math.random() * 2 - 1) * 70);
    }
    return out;
  }

  function filterDeepfry(data, w, h) {
    var d = applyContrastRaw(data, (259 * 355) / (255 * 159));
    d = applySaturateRaw(d, 3);
    return applyNoiseRaw(d, 40);
  }

  function filterMode1994(data, w, h) {
    return applyNoiseRaw(filterGrayscale(data), 30);
  }

  function applyFilter(name, data, w, h) {
    switch (name) {
      case 'deepfry':    return filterDeepfry(data, w, h);
      case 'glitch':     return filterGlitch(data, w, h);
      case 'halftone':   return filterHalftone(data, w, h);
      case 'posterize':  return filterPosterize(data);
      case 'vibe':       return filterVibe(data);
      case 'squiche':    return filterHalftone(data, w, h);
      case 'mode1994':   return filterMode1994(data, w, h);
      case 'grayscale':  return filterGrayscale(data);
      case 'brightness': return filterBrightness(data);
      case 'darken':     return filterDarken(data);
      case 'contrast':   return filterContrast(data);
      case 'saturate':   return filterSaturate(data);
      case 'invert':     return filterInvert(data);
      case 'noise':      return filterNoise(data);
      case 'blur':       return filterBlur(data, w, h);
      case 'sharpen':    return filterSharpen(data, w, h);
      default:           return new Uint8ClampedArray(data);
    }
  }

  /* ── Filter runner ── */
  function runFilter(filterName, btn, iframe) {
    if (!iframe || !iframe.contentWindow) return;
    btn.classList.add('psf-busy');

    var msgId = 'psf-' + Date.now() + '-' + Math.random();
    var handled = false;

    var timeout = setTimeout(function () {
      if (handled) return;
      handled = true;
      window.removeEventListener('message', handler);
      btn.classList.remove('psf-busy');
      if (window.OS9Windows && window.OS9Windows.showDialog) {
        window.OS9Windows.showDialog({
          title: 'Filter Error',
          message: 'Could not read canvas. Make sure jspaint has loaded and you have drawn something first.',
          icon: '&#9888;',
          buttons: 'OK'
        });
      }
    }, 3000);

    function handler(e) {
      if (!e.data || e.data.id !== msgId) return;
      if (handled) return;
      handled = true;
      clearTimeout(timeout);
      window.removeEventListener('message', handler);

      var w = e.data.width;
      var h = e.data.height;
      var raw = new Uint8ClampedArray(e.data.imageData);
      var filtered = applyFilter(filterName, raw, w, h);

      iframe.contentWindow.postMessage({
        type: 'set_canvas_image_data',
        imageData: Array.from(filtered),
        width: w,
        height: h
      }, '*');

      setTimeout(function () { btn.classList.remove('psf-busy'); }, 300);
    }

    window.addEventListener('message', handler);
    iframe.contentWindow.postMessage({ type: 'get_canvas_image_data', id: msgId }, '*');
  }

  /* ── Open JSPaint ── */
  function openJSPaint() {
    if (!window.OS9Windows) return;
    injectFilterStyles();

    var existing = document.getElementById('jspaint-win');
    if (existing) { window.OS9Windows.focusWindow(existing); return; }

    var desktop = document.getElementById('os9-desktop-area') || document.body;
    var b  = window.OS9Windows ? window.OS9Windows.getDesktopBounds() : { top: 22, left: 0, width: desktop.offsetWidth || window.innerWidth - 96, height: desktop.offsetHeight || window.innerHeight - 46 };

    /* ── Main window — opens full-screen ── */
    var el = window.OS9Windows._buildWindow({
      id: 'jspaint-win',
      title: 'JS Paint',
      width: b.width, height: b.height,
      x: 0, y: b.top
    });
    desktop.appendChild(el);
    window.OS9Windows._initWindow(el, 'jspaint-win');
    el.style.left   = '0';
    el.style.top    = b.top + 'px';
    el.style.width  = b.width  + 'px';
    el.style.height = b.height + 'px';
    el.style.zIndex = (++window._os9TopZ) + '';
    el.dataset.zoomed = '1';
    // Mobile: trigger the zoom button so the window uses position:fixed covering the
    // dock/sidebar — same as pressing zoom manually. initZoom saves the desktop-area
    // style above as the restore point, then applies the full-root fixed geometry.
    if (window.innerWidth <= 749) {
      var zoomBtn = el.querySelector('[data-zoom]');
      if (zoomBtn) zoomBtn.click();
    }

    var body = el.querySelector('[data-body]');
    body.style.cssText = 'padding:0;overflow:hidden;height:100%;display:flex;flex:1;';

    var iframe = document.createElement('iframe');
    iframe.id = 'jspaint-iframe';
    iframe.src = 'https://jspaint.app';
    iframe.style.cssText = 'width:100%;height:100%;border:none;display:block;flex:1;min-height:0;';
    body.appendChild(iframe);

    var infobar = el.querySelector('[data-infobar]');
    if (infobar) infobar.textContent = 'jspaint.app';

    /* ── Filter palette window ──
       TODO: Squiche Filters are hidden until the postMessage bridge with jspaint.app
       is stable (get_canvas_image_data / set_canvas_image_data timing is flaky on
       cross-origin iframes). To re-enable: remove the filterEl.style.display line below.
       All filter logic (applyFilter, runFilter, filterBody HTML) is intact above — nothing
       needs to be rebuilt, just un-hidden. */
    var filterEl = window.OS9Windows._buildWindow({
      id: 'jspaint-filters-win',
      title: '✦ Squiche Filters',
      width: 220, height: 360,
      x: Math.max(0, b.width - 230), y: b.top + 40
    });
    desktop.appendChild(filterEl);
    window.OS9Windows._initWindow(filterEl, 'jspaint-filters-win');
    filterEl.style.display = 'none'; /* hidden — see TODO above */

    var filterBody = filterEl.querySelector('[data-body]');
    filterBody.style.cssText = 'padding:6px;overflow:visible;';

    var filterInf = filterEl.querySelector('[data-infobar]');
    if (filterInf) filterInf.textContent = 'Click a filter to apply';

    filterBody.innerHTML =
      '<div class="psf-label">Pixel</div>' +
      '<div class="psf-row">' +
        '<button class="psf-btn" data-filter="deepfry">🔥 Deep Fry</button>' +
        '<button class="psf-btn" data-filter="glitch">⚡ Glitch</button>' +
      '</div>' +
      '<div class="psf-row">' +
        '<button class="psf-btn" data-filter="halftone">⬤ Halftone</button>' +
        '<button class="psf-btn" data-filter="posterize">Posterize</button>' +
      '</div>' +
      '<div class="psf-divider"></div>' +
      '<div class="psf-label">Vibe</div>' +
      '<div class="psf-row">' +
        '<button class="psf-btn" data-filter="vibe">✨ Vibe Check</button>' +
        '<button class="psf-btn" data-filter="squiche">🏴 Make it Squiche</button>' +
      '</div>' +
      '<div class="psf-row">' +
        '<button class="psf-btn" data-filter="mode1994">📼 1994 Mode</button>' +
        '<button class="psf-btn" data-filter="grayscale">Grayscale</button>' +
      '</div>' +
      '<div class="psf-divider"></div>' +
      '<div class="psf-label">Adjust</div>' +
      '<div class="psf-row">' +
        '<button class="psf-btn" data-filter="brightness">Brightness +</button>' +
        '<button class="psf-btn" data-filter="darken">Brightness −</button>' +
      '</div>' +
      '<div class="psf-row">' +
        '<button class="psf-btn" data-filter="contrast">Contrast +</button>' +
        '<button class="psf-btn" data-filter="saturate">Saturate</button>' +
      '</div>' +
      '<div class="psf-row">' +
        '<button class="psf-btn" data-filter="invert">Invert</button>' +
        '<button class="psf-btn" data-filter="noise">Add Noise</button>' +
      '</div>' +
      '<div class="psf-row">' +
        '<button class="psf-btn" data-filter="blur">Blur</button>' +
        '<button class="psf-btn" data-filter="sharpen">Sharpen</button>' +
      '</div>';

    filterBody.querySelectorAll('.psf-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        runFilter(btn.dataset.filter, btn, iframe);
      });
    });

    /* ── Close behavior ── */
    var mainCloseBtn = el.querySelector('[data-close]');
    if (mainCloseBtn) {
      mainCloseBtn.addEventListener('click', function () {
        var fw = document.getElementById('jspaint-filters-win');
        if (fw) fw.remove();
      });
    }
  }

  window.AppJSPaint = { open: openJSPaint };

})();